import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If react-snap pre-rendered HTML exists, hydrate instead of full render
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(app);
}

// Listen for service worker updates — log only, never auto-reload
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    console.log('New service worker activated. Refresh for the latest version.');
  });

  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'SW_UPDATED') {
      console.log('New version available. Refresh for the latest version.');
    }
  });
}

// Register service worker for offline access (paid tier feature)
serviceWorkerRegistration.register({
  onSuccess: () => console.log('Offline access enabled'),
  onUpdate: () => {
    console.log('New service worker version available.');
  },
});
